import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneCrossFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M9.2 10.45c-.449-.27-1.162-.772-2.013-1.621-.854-.854-1.355-1.57-1.625-2.02-.19-.314-.187-.695-.043-1.032l.868-2.03L3.78 0c-6.136 1.732-3.936 7.351.475 11.76 4.41 4.41 10.009 6.585 11.745.455L12.252 9.61l-2.007.878c-.34.149-.726.153-1.045-.038"
                    fill="currentColor"
                />
                <path
                    d="m15.398 5.077-1.745-1.744 1.745-1.745-.99-.99-1.745 1.745L10.92.598l-.99.99 1.744 1.745L9.93 5.077l.99.99 1.744-1.745 1.745 1.745z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneCrossFilledSize16Glyph.displayName = 'PhoneCrossFilledSize16Glyph';
